import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import Alert from '../common/Alert';

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    position: 'fixed',
    top: 0,
    zIndex: 10000000000,
  },
}));

const FlashMessage = (props) => {
  const { mobile } = props;
  const classes = useStyles({ mobile });
  const [visible, setVisible] = useState(false);
  const flash = useSelector((state) => state.flashReducer);

  useEffect(() => {
    if (flash.visible) {
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, flash.timeout);
    }
  }, [flash]);

  return (
    <div className={classes.container}>
      {visible && <Alert severity={flash.state} message={flash.message} />}
    </div>
  );
};

FlashMessage.propTypes = {
  mobile: PropTypes.bool,
};

export default FlashMessage;
